import { __ } from '@wordpress/i18n';
import {
	PanelBody,
	PanelRow,
	CheckboxControl,
	TextControl,
} from '@wordpress/components';

const CloseTriggers = ( props ) => {
	const { attributes, setAttributes } = props;
	const { triggers, settings } = attributes;

	const changeAttribute = ( triggerName, triggerType, val ) => {
		setAttributes( {
			settings: {
				...settings,
				[ triggerName ]: { [ triggerType ]: val },
			},
		} );
	};

	const handleChangeCloseTriggers = ( trigger, val ) => {
		let filteredArray = [];
		if ( val ) {
			filteredArray = [ ...triggers, trigger ];
		} else {
			filteredArray = triggers.filter( ( item ) => item !== trigger );
		}
		setAttributes( {
			triggers: filteredArray,
		} );
	};

	return (
		<PanelBody
			initialOpen={ false }
			title={ __( 'Close Trigger', 'popper' ) }
		>
			<PanelRow>
				<CheckboxControl
					label={ __( 'Close On Click Outside', 'popper' ) }
					checked={ triggers.includes( 'closeOnClickOutside' ) }
					onChange={ ( val ) =>
						handleChangeCloseTriggers( 'closeOnClickOutside', val )
					}
				/>
			</PanelRow>
			<PanelRow>
				<CheckboxControl
					label={ __( 'Close on form submission', 'popper' ) }
					checked={ triggers.includes( 'closeOnFormSubmission' ) }
					onChange={ ( val ) =>
						handleChangeCloseTriggers(
							'closeOnFormSubmission',
							val
						)
					}
				/>
			</PanelRow>
			<PanelRow>
				<CheckboxControl
					label={ __( 'Close On Anchor Click', 'popper' ) }
					checked={ triggers.includes( 'closeOnAnchorClick' ) }
					onChange={ ( val ) =>
						handleChangeCloseTriggers( 'closeOnAnchorClick', val )
					}
				/>
			</PanelRow>
			{ triggers.includes( 'closeOnAnchorClick' ) && (
				<PanelRow>
					<TextControl
						value={ settings.closeAnchor?.target || '' }
						label={ __( 'Anchor', 'popper' ) }
						help={
							<small>
								{ __(
									'You can add anchors to button blocks. Using the same anchor here will close the modal when you click the respective button.',
									'popper'
								) }
							</small>
						}
						onChange={ ( val ) =>
							changeAttribute( 'closeAnchor', 'target', val )
						}
					/>
				</PanelRow>
			) }
		</PanelBody>
	);
};

export default CloseTriggers;
